import { nonSeeded } from "../fable_modules/fable-library.3.7.14/Random.js";
import { reverse as reverse_1, ofArray, filter, tryHead, length, item } from "../fable_modules/fable-library.3.7.14/List.js";
import { GameObject, Enemy__get_IsAlive, PathState, BasicGameObject as BasicGameObject_4, Vector2D_op_Addition_3C4D5180, Vector2D__get_Magnitude, Vector2D_op_Multiply_Z23A8CFC1, Vector2D_op_Subtraction_3C4D5180, Game, ViewportFilter as ViewportFilter_1, OverlayAnimation_Blood_5E38073B, Player as Player_1, Enemy__get_IsVisible, Game__get_IsPlayerRunning, Enemy__get_IsBoss, SoundEffect, Enemy_AnimationTimeForState_4C3F69DE, MapDirection_Diagonal, Enemy, EnemyStateType, Game__get_PlayerMapPosition, MapDirection__Reverse, BasicGameObject__get_MapPosition, MapDirection__ToDelta, MapDirection, Vector2D__Abs, Vector2D_op_Division_Z23A8CFC1, Vector2D__Normalize, Vector2D__Rotate_Z114CB6F, Vector2D, Enemy__get_DirectionVector } from "../Model.fs.js";
import { canEnemyTraverse, cast, isPointInTriangle } from "./Ray.fs.js";
import { comparePrimitives, max, equals } from "../fable_modules/fable-library.3.7.14/Util.js";
import { log } from "../Utils.fs.js";
import { tryHead as tryHead_1, reverse, map } from "../fable_modules/fable-library.3.7.14/Array.js";
import { singleton, append, delay, toArray } from "../fable_modules/fable-library.3.7.14/Seq.js";
import { map as map_1, defaultArgWith, some, value as value_1 } from "../fable_modules/fable-library.3.7.14/Option.js";
import { playAttackSound, playSoundEffect } from "./Audio.fs.js";

const randomGenerator = nonSeeded();

export function List_random(values) {
    return item(randomGenerator.Next2(0, length(values)), values);
}

export function inFieldOfView(game, enemy) {
    const matchValue = Enemy__get_DirectionVector(enemy);
    if (matchValue != null) {
        const directionVector = matchValue;
        const fieldOfViewAngle = ((60 * 3.141592653589793) / 180) * 1;
        return isPointInTriangle(new Vector2D(0, 0), Vector2D__Rotate_Z114CB6F(Vector2D__Normalize(directionVector), -fieldOfViewAngle), Vector2D__Rotate_Z114CB6F(Vector2D__Normalize(directionVector), fieldOfViewAngle), Vector2D_op_Division_Z23A8CFC1(Vector2D__Normalize(new Vector2D(game.Camera.Position.vX - enemy.BasicGameObject.Position.vX, game.Camera.Position.vY - enemy.BasicGameObject.Position.vY)), 2));
    }
    else {
        return true;
    }
}

export function isPlayerVisibleToEnemy(game, enemy) {
    if (inFieldOfView(game, enemy)) {
        const vectorToEnemy = new Vector2D(game.Camera.Position.vX - enemy.BasicGameObject.Position.vX, game.Camera.Position.vY - enemy.BasicGameObject.Position.vY);
        const absVectorToEnemy = Vector2D__Abs(vectorToEnemy);
        const rayDirection = Vector2D__Normalize(vectorToEnemy);
        return !cast(() => [false, enemy.BasicGameObject.Position.vX, enemy.BasicGameObject.Position.vY, rayDirection], (tupledArg) => {
            const mapX = tupledArg[3] | 0;
            const mapY = tupledArg[4] | 0;
            if ((!tupledArg[0]) && ((((mapX >= 0) && (mapX < length(item(0, game.Map)))) && (mapY >= 0)) && (mapY < length(game.Map)))) {
                if (Math.abs(tupledArg[1]) < absVectorToEnemy.vX) {
                    return true;
                }
                else {
                    return Math.abs(tupledArg[2]) < absVectorToEnemy.vY;
                }
            }
            else {
                return false;
            }
        }, game)[0];
    }
    else {
        return false;
    }
}

export function canMove(game, enemy, mapDirection) {
    if (equals(mapDirection, new MapDirection(8))) {
        return false;
    }
    else {
        const patternInput = MapDirection__ToDelta(mapDirection);
        const patternInput_1 = BasicGameObject__get_MapPosition(enemy.BasicGameObject);
        const patternInput_2 = [patternInput_1[0] + patternInput[0], patternInput_1[1] + patternInput[1]];
        return canEnemyTraverse(game, patternInput_2[0], patternInput_2[1]);
    }
}

export function setupChaseState(game, enemy) {
    let d;
    const turnaround = MapDirection__Reverse(enemy.Direction);
    const patternInput = Game__get_PlayerMapPosition(game);
    const patternInput_1 = BasicGameObject__get_MapPosition(enemy.BasicGameObject);
    const enemyY = patternInput_1[1] | 0;
    const enemyX = patternInput_1[0] | 0;
    const deltaX = (patternInput[0] - enemyX) | 0;
    const deltaY = (patternInput[1] - enemyY) | 0;
    log(`Setting up chase state: ${enemyX}, ${enemyY}`);
    const dir = map((d_1) => {
        if (equals(d_1, turnaround)) {
            return new MapDirection(8);
        }
        else {
            return d_1;
        }
    }, (d = toArray(delay(() => append((deltaX > 0) ? singleton(new MapDirection(6)) : ((deltaX < 0) ? singleton(new MapDirection(2)) : singleton(new MapDirection(8))), delay(() => ((deltaY > 0) ? singleton(new MapDirection(4)) : ((deltaY < 0) ? singleton(new MapDirection(0)) : singleton(new MapDirection(8)))))))), (Math.abs(deltaY) > Math.abs(deltaX)) ? reverse(d) : d));
    const updateEnemy = (withDirection) => {
        const patternInput_2 = MapDirection__ToDelta(withDirection);
        const patternInput_3 = BasicGameObject__get_MapPosition(enemy.BasicGameObject);
        const patternInput_4 = [patternInput_3[0] + patternInput_2[0], patternInput_3[1] + patternInput_2[1]];
        return new Enemy(enemy.EnemyType, enemy.BasicGameObject, withDirection, enemy.DeathSpriteIndexes, enemy.AttackSpriteIndexes, enemy.SpriteBlocks, enemy.FramesPerBlock, enemy.CurrentAnimationFrame, enemy.TimeUntilNextAnimationFrame, new EnemyStateType(6, patternInput_4[0], patternInput_4[1]), enemy.IsFirstAttack, enemy.FireAtPlayerRequired, enemy.MoveToChaseRequired, enemy.HitPoints, enemy.HurtSpriteIndex, enemy.PatrolSpeed, enemy.ChaseSpeed);
    };
    const onNone = (func, optionValue) => {
        if (optionValue == null) {
            return func();
        }
        else {
            return some(value_1(optionValue));
        }
    };
    return defaultArgWith(onNone(() => (canMove(game, enemy, turnaround) ? updateEnemy(turnaround) : (void 0)), onNone(() => {
        let values;
        return map_1(updateEnemy, tryHead(filter((direction) => canMove(game, enemy, direction), (values = ofArray([new MapDirection(0), new MapDirection(7), new MapDirection(6)]), (randomGenerator.Next1(255) > 128) ? values : reverse_1(values)))));
    }, onNone(() => (canMove(game, enemy, enemy.Direction) ? updateEnemy(enemy.Direction) : (void 0)), onNone(() => (canMove(game, enemy, dir[1]) ? updateEnemy(dir[1]) : (void 0)), canMove(game, enemy, dir[0]) ? updateEnemy(dir[0]) : (void 0))))), () => (new Enemy(enemy.EnemyType, enemy.BasicGameObject, new MapDirection(8), enemy.DeathSpriteIndexes, enemy.AttackSpriteIndexes, enemy.SpriteBlocks, enemy.FramesPerBlock, enemy.CurrentAnimationFrame, enemy.TimeUntilNextAnimationFrame, new EnemyStateType(0), enemy.IsFirstAttack, enemy.FireAtPlayerRequired, enemy.MoveToChaseRequired, enemy.HitPoints, enemy.HurtSpriteIndex, enemy.PatrolSpeed, enemy.ChaseSpeed)));
}

export function setupChaseStateWithDodge(game, enemy) {
    let array, dt_2, dt, dt_1, arg10;
    const turnaround = enemy.IsFirstAttack ? (new MapDirection(8)) : MapDirection__Reverse(enemy.Direction);
    const patternInput = Game__get_PlayerMapPosition(game);
    const patternInput_1 = BasicGameObject__get_MapPosition(enemy.BasicGameObject);
    const deltaX_1 = (patternInput[0] - patternInput_1[0]) | 0;
    const deltaY_1 = (patternInput[1] - patternInput_1[1]) | 0;
    const directionOption = tryHead_1((array = ((dt_2 = ((dt = ((dt_1 = toArray(delay(() => append(singleton(new MapDirection(8)), delay(() => append((deltaX_1 > 0) ? singleton(new MapDirection(6)) : singleton(new MapDirection(2)), delay(() => append((deltaY_1 > 0) ? singleton(new MapDirection(4)) : singleton(new MapDirection(0)), delay(() => append((deltaX_1 > 0) ? singleton(new MapDirection(2)) : singleton(new MapDirection(6)), delay(() => ((deltaY_1 > 0) ? singleton(new MapDirection(0)) : singleton(new MapDirection(4))))))))))))), (Math.abs(deltaX_1) > Math.abs(deltaY_1)) ? [dt_1[0], dt_1[2], dt_1[1], dt_1[4], dt_1[3]] : dt_1)), (randomGenerator.Next1(255) < 128) ? [dt[0], dt[2], dt[1], dt[4], dt[3]] : dt)), [(arg10 = dt_2[2], MapDirection_Diagonal(dt_2[1], arg10)), dt_2[1], dt_2[2], dt_2[3], dt_2[4]])), array.filter((direction) => {
        if (equals(direction, new MapDirection(8)) ? true : equals(direction, turnaround)) {
            return false;
        }
        else {
            return canMove(game, enemy, direction);
        }
    })));
    if (directionOption == null) {
        return enemy;
    }
    else {
        const direction_1 = directionOption;
        const patternInput_2 = MapDirection__ToDelta(direction_1);
        const patternInput_3 = BasicGameObject__get_MapPosition(enemy.BasicGameObject);
        const patternInput_4 = [patternInput_3[0] + patternInput_2[0], patternInput_3[1] + patternInput_2[1]];
        return new Enemy(enemy.EnemyType, enemy.BasicGameObject, direction_1, enemy.DeathSpriteIndexes, enemy.AttackSpriteIndexes, enemy.SpriteBlocks, enemy.FramesPerBlock, enemy.CurrentAnimationFrame, enemy.TimeUntilNextAnimationFrame, new EnemyStateType(6, patternInput_4[0], patternInput_4[1]), enemy.IsFirstAttack, enemy.FireAtPlayerRequired, enemy.MoveToChaseRequired, enemy.HitPoints, enemy.HurtSpriteIndex, enemy.PatrolSpeed, enemy.ChaseSpeed);
    }
}

export function createAttackState(game, enemy) {
    return new Enemy(enemy.EnemyType, enemy.BasicGameObject, new MapDirection(8), enemy.DeathSpriteIndexes, enemy.AttackSpriteIndexes, enemy.SpriteBlocks, enemy.FramesPerBlock, 0, Enemy_AnimationTimeForState_4C3F69DE(new EnemyStateType(2)), new EnemyStateType(2), false, enemy.FireAtPlayerRequired, enemy.MoveToChaseRequired, enemy.HitPoints, enemy.HurtSpriteIndex, enemy.PatrolSpeed, enemy.ChaseSpeed);
}

export function createChaseState(canSeePlayer, game, enemy) {
    let updatedEnemy;
    if (canSeePlayer) {
        const matchValue = enemy.State;
        switch (matchValue.tag) {
            case 1:
            case 0:
            case 3: {
                playSoundEffect(game, enemy.BasicGameObject.Position, new SoundEffect(0));
                break;
            }
            default: {
            }
        }
        const patternInput = BasicGameObject__get_MapPosition(enemy.BasicGameObject);
        const patternInput_1 = Game__get_PlayerMapPosition(game);
        const absDeltaX = Math.abs(patternInput[0] - patternInput_1[0]) | 0;
        const absDeltaY = Math.abs(patternInput[1] - patternInput_1[1]) | 0;
        const distance = ((absDeltaX > absDeltaY) ? absDeltaX : absDeltaY) | 0;
        updatedEnemy = (((log(`Shoot Distance: ${distance}`), (distance <= 1) ? true : (equals(enemy.State, new EnemyStateType(2)) ? (randomGenerator.Next1(255) < (~(~(255 / distance)))) : (randomGenerator.Next1(255) < (~(~(255 / max(comparePrimitives, 1, (~(~(distance / 3))) * 2)))))))) ? createAttackState(game, enemy) : setupChaseStateWithDodge(game, enemy));
    }
    else {
        updatedEnemy = setupChaseState(game, enemy);
    }
    if (updatedEnemy.MoveToChaseRequired) {
        playSoundEffect(game, enemy.BasicGameObject.Position, new SoundEffect(0));
    }
    return new Enemy(updatedEnemy.EnemyType, updatedEnemy.BasicGameObject, updatedEnemy.Direction, updatedEnemy.DeathSpriteIndexes, updatedEnemy.AttackSpriteIndexes, updatedEnemy.SpriteBlocks, updatedEnemy.FramesPerBlock, updatedEnemy.CurrentAnimationFrame, updatedEnemy.TimeUntilNextAnimationFrame, updatedEnemy.State, updatedEnemy.IsFirstAttack, updatedEnemy.FireAtPlayerRequired, false, updatedEnemy.HitPoints, updatedEnemy.HurtSpriteIndex, updatedEnemy.PatrolSpeed, updatedEnemy.ChaseSpeed);
}

export function getNextState(canSeePlayer, game, enemy) {
    const matchValue = [enemy.State, canSeePlayer];
    let pattern_matching_result;
    if (matchValue[0].tag === 0) {
        if (matchValue[1]) {
            pattern_matching_result = 0;
        }
        else {
            pattern_matching_result = 2;
        }
    }
    else if (matchValue[0].tag === 1) {
        if (matchValue[1]) {
            pattern_matching_result = 0;
        }
        else {
            pattern_matching_result = 2;
        }
    }
    else if (matchValue[0].tag === 2) {
        pattern_matching_result = 1;
    }
    else {
        pattern_matching_result = 2;
    }
    switch (pattern_matching_result) {
        case 0: {
            return createChaseState(canSeePlayer, game, enemy);
        }
        case 1: {
            if (enemy.TimeUntilNextAnimationFrame < 0) {
                return createChaseState(canSeePlayer, game, enemy);
            }
            else {
                return enemy;
            }
        }
        case 2: {
            return enemy;
        }
    }
}

export function preProcess(canSeePlayer, enemy, game) {
    return [getNextState(canSeePlayer, game, enemy), game];
}

export function firingOnPlayer(canSeePlayer, enemy, game) {
    let inputRecord;
    let damage;
    if (enemy.FireAtPlayerRequired && canSeePlayer) {
        const patternInput = BasicGameObject__get_MapPosition(enemy.BasicGameObject);
        const patternInput_1 = Game__get_PlayerMapPosition(game);
        const deltaX = Math.abs(patternInput[0] - patternInput_1[0]) | 0;
        const deltaY = Math.abs(patternInput[1] - patternInput_1[1]) | 0;
        let distance;
        const matchValue = [enemy.EnemyType, Enemy__get_IsBoss(enemy)];
        let pattern_matching_result;
        if (matchValue[0].tag === 2) {
            pattern_matching_result = 0;
        }
        else if (matchValue[1]) {
            pattern_matching_result = 0;
        }
        else {
            pattern_matching_result = 1;
        }
        switch (pattern_matching_result) {
            case 0: {
                distance = (~(~((max(comparePrimitives, deltaX, deltaY) * 2) / 3)));
                break;
            }
            case 1: {
                distance = max(comparePrimitives, deltaX, deltaY);
                break;
            }
        }
        const hitchance = (Game__get_IsPlayerRunning(game) ? (Enemy__get_IsVisible(enemy) ? (160 - (distance * 16)) : (160 - (distance * 8))) : (Enemy__get_IsVisible(enemy) ? (256 - (distance * 16)) : (160 - (distance * 8)))) | 0;
        playAttackSound(game, enemy.BasicGameObject.Position, enemy.EnemyType);
        damage = ((randomGenerator.Next1(255) < hitchance) ? ((distance < 2) ? (randomGenerator.Next1(255) >> 2) : ((distance < 4) ? (randomGenerator.Next1(255) >> 3) : (randomGenerator.Next1(255) >> 4))) : 0);
    }
    else {
        damage = 0;
    }
    return [enemy, new Game(game.Level, game.Map, game.Areas, game.CompositeAreas, game.GameObjects, (inputRecord = game.Player, new Player_1(inputRecord.Score, inputRecord.Lives, game.Player.Health - (damage * 1), inputRecord.Radius, inputRecord.CurrentWeaponIndex, inputRecord.Ammunition, inputRecord.Weapons, inputRecord.CurrentFaceIndex, inputRecord.TimeToFaceChangeMs)), game.Camera, game.ControlState, game.IsFiring, game.TimeToNextWeaponFrame, game.Doors, (damage > 0) ? (new ViewportFilter_1(1, OverlayAnimation_Blood_5E38073B(damage / 64))) : game.ViewportFilter, game.PixelDissolver, game.ResetLevel)];
}

export function updateBasedOnCurrentState(canSeePlayer, frameTime, enemy, game) {
    let inputRecord, inputRecord_1, inputRecord_2, inputRecord_3;
    const matchValue = [enemy.State, Enemy__get_DirectionVector(enemy)];
    let pattern_matching_result, previousState, direction, targetMapX, targetMapY, direction_1, pathState;
    if (matchValue[0].tag === 4) {
        pattern_matching_result = 0;
        previousState = matchValue[0].fields[0];
    }
    else if (matchValue[0].tag === 6) {
        if (matchValue[1] != null) {
            pattern_matching_result = 1;
            direction = matchValue[1];
            targetMapX = matchValue[0].fields[0];
            targetMapY = matchValue[0].fields[1];
        }
        else {
            pattern_matching_result = 4;
        }
    }
    else if (matchValue[0].tag === 3) {
        if (matchValue[1] != null) {
            pattern_matching_result = 2;
            direction_1 = matchValue[1];
            pathState = matchValue[0].fields[0];
        }
        else {
            pattern_matching_result = 4;
        }
    }
    else if (matchValue[0].tag === 0) {
        pattern_matching_result = 3;
    }
    else {
        pattern_matching_result = 4;
    }
    switch (pattern_matching_result) {
        case 0: {
            if (enemy.TimeUntilNextAnimationFrame < 0) {
                return [new Enemy(enemy.EnemyType, enemy.BasicGameObject, enemy.Direction, enemy.DeathSpriteIndexes, enemy.AttackSpriteIndexes, enemy.SpriteBlocks, enemy.FramesPerBlock, enemy.CurrentAnimationFrame, Enemy_AnimationTimeForState_4C3F69DE(previousState), previousState, enemy.IsFirstAttack, enemy.FireAtPlayerRequired, enemy.MoveToChaseRequired, enemy.HitPoints, enemy.HurtSpriteIndex, enemy.PatrolSpeed, enemy.ChaseSpeed), game];
            }
            else {
                return [enemy, game];
            }
        }
        case 1: {
            const targetPosition = new Vector2D(targetMapX + 0.5, targetMapY + 0.5);
            const distanceToTarget = Vector2D_op_Subtraction_3C4D5180(targetPosition, enemy.BasicGameObject.Position);
            const frameRateBasedDelta = Vector2D_op_Multiply_Z23A8CFC1(direction, (frameTime / 1000) * enemy.ChaseSpeed);
            if (Vector2D__get_Magnitude(distanceToTarget) > Vector2D__get_Magnitude(frameRateBasedDelta)) {
                return [new Enemy(enemy.EnemyType, (inputRecord = enemy.BasicGameObject, new BasicGameObject_4(Vector2D_op_Addition_3C4D5180(enemy.BasicGameObject.Position, frameRateBasedDelta), inputRecord.PlayerRelativePosition, inputRecord.UnsquaredDistanceFromPlayer, inputRecord.SpriteIndex, inputRecord.CollidesWithBullets, inputRecord.Pickupable, inputRecord.HitpointsRestored, inputRecord.AmmoRestored, inputRecord.LivesRestored, inputRecord.Score, inputRecord.Blocking)), enemy.Direction, enemy.DeathSpriteIndexes, enemy.AttackSpriteIndexes, enemy.SpriteBlocks, enemy.FramesPerBlock, enemy.CurrentAnimationFrame, enemy.TimeUntilNextAnimationFrame, enemy.State, enemy.IsFirstAttack, enemy.FireAtPlayerRequired, enemy.MoveToChaseRequired, enemy.HitPoints, enemy.HurtSpriteIndex, enemy.PatrolSpeed, enemy.ChaseSpeed), game];
            }
            else {
                return [createChaseState(canSeePlayer, game, new Enemy(enemy.EnemyType, (inputRecord_1 = enemy.BasicGameObject, new BasicGameObject_4(targetPosition, inputRecord_1.PlayerRelativePosition, inputRecord_1.UnsquaredDistanceFromPlayer, inputRecord_1.SpriteIndex, inputRecord_1.CollidesWithBullets, inputRecord_1.Pickupable, inputRecord_1.HitpointsRestored, inputRecord_1.AmmoRestored, inputRecord_1.LivesRestored, inputRecord_1.Score, inputRecord_1.Blocking)), enemy.Direction, enemy.DeathSpriteIndexes, enemy.AttackSpriteIndexes, enemy.SpriteBlocks, enemy.FramesPerBlock, enemy.CurrentAnimationFrame, enemy.TimeUntilNextAnimationFrame, enemy.State, enemy.IsFirstAttack, enemy.FireAtPlayerRequired, enemy.MoveToChaseRequired, enemy.HitPoints, enemy.HurtSpriteIndex, enemy.PatrolSpeed, enemy.ChaseSpeed)), game];
            }
        }
        case 2: {
            const targetMapX_1 = pathState.TargetX | 0;
            const targetMapY_1 = pathState.TargetY | 0;
            const targetPosition_1 = new Vector2D(targetMapX_1 + 0.5, targetMapY_1 + 0.5);
            const distanceToTarget_1 = Vector2D_op_Subtraction_3C4D5180(targetPosition_1, enemy.BasicGameObject.Position);
            const frameRateBasedDelta_1 = Vector2D_op_Multiply_Z23A8CFC1(direction_1, (frameTime / 1000) * enemy.PatrolSpeed);
            if (Vector2D__get_Magnitude(distanceToTarget_1) > Vector2D__get_Magnitude(frameRateBasedDelta_1)) {
                return [new Enemy(enemy.EnemyType, (inputRecord_2 = enemy.BasicGameObject, new BasicGameObject_4(Vector2D_op_Addition_3C4D5180(enemy.BasicGameObject.Position, frameRateBasedDelta_1), inputRecord_2.PlayerRelativePosition, inputRecord_2.UnsquaredDistanceFromPlayer, inputRecord_2.SpriteIndex, inputRecord_2.CollidesWithBullets, inputRecord_2.Pickupable, inputRecord_2.HitpointsRestored, inputRecord_2.AmmoRestored, inputRecord_2.LivesRestored, inputRecord_2.Score, inputRecord_2.Blocking)), enemy.Direction, enemy.DeathSpriteIndexes, enemy.AttackSpriteIndexes, enemy.SpriteBlocks, enemy.FramesPerBlock, enemy.CurrentAnimationFrame, enemy.TimeUntilNextAnimationFrame, enemy.State, enemy.IsFirstAttack, enemy.FireAtPlayerRequired, enemy.MoveToChaseRequired, enemy.HitPoints, enemy.HurtSpriteIndex, enemy.PatrolSpeed, enemy.ChaseSpeed), game];
            }
            else if ((canSeePlayer ? true : pathState.ChaseOnTargetReached) ? true : enemy.MoveToChaseRequired) {
                return [createChaseState(canSeePlayer, game, enemy), game];
            }
            else {
                let newDirection;
                const matchValue_1 = item(targetMapX_1, item(targetMapY_1, game.Map));
                newDirection = ((matchValue_1.tag === 2) ? matchValue_1.fields[0] : enemy.Direction);
                const patternInput = MapDirection__ToDelta(newDirection);
                const turnedEnemy = new Enemy(enemy.EnemyType, (inputRecord_3 = enemy.BasicGameObject, new BasicGameObject_4(targetPosition_1, inputRecord_3.PlayerRelativePosition, inputRecord_3.UnsquaredDistanceFromPlayer, inputRecord_3.SpriteIndex, inputRecord_3.CollidesWithBullets, inputRecord_3.Pickupable, inputRecord_3.HitpointsRestored, inputRecord_3.AmmoRestored, inputRecord_3.LivesRestored, inputRecord_3.Score, inputRecord_3.Blocking)), newDirection, enemy.DeathSpriteIndexes, enemy.AttackSpriteIndexes, enemy.SpriteBlocks, enemy.FramesPerBlock, enemy.CurrentAnimationFrame, enemy.TimeUntilNextAnimationFrame, new EnemyStateType(3, new PathState(targetMapX_1 + patternInput[0], targetMapY_1 + patternInput[1], pathState.ChaseOnTargetReached)), enemy.IsFirstAttack, enemy.FireAtPlayerRequired, enemy.MoveToChaseRequired, enemy.HitPoints, enemy.HurtSpriteIndex, enemy.PatrolSpeed, enemy.ChaseSpeed);
                return [isPlayerVisibleToEnemy(game, turnedEnemy) ? createChaseState(canSeePlayer, game, turnedEnemy) : turnedEnemy, game];
            }
        }
        case 3: {
            if (enemy.MoveToChaseRequired) {
                return [createChaseState(canSeePlayer, game, enemy), game];
            }
            else {
                return [enemy, game];
            }
        }
        case 4: {
            return [enemy, game];
        }
    }
}

export function applyAi(frameTime, game, gameObject, newObjects) {
    if (gameObject.tag === 1) {
        const enemy = gameObject.fields[0];
        if (Enemy__get_IsAlive(enemy)) {
            const canSeePlayer = isPlayerVisibleToEnemy(game, enemy);
            let patternInput;
            let tupledArg_2;
            let tupledArg_1;
            const tupledArg = [enemy, game];
            tupledArg_1 = preProcess(canSeePlayer, tupledArg[0], tupledArg[1]);
            tupledArg_2 = updateBasedOnCurrentState(canSeePlayer, frameTime, tupledArg_1[0], tupledArg_1[1]);
            patternInput = firingOnPlayer(canSeePlayer, tupledArg_2[0], tupledArg_2[1]);
            return [patternInput[1], new GameObject(1, patternInput[0]), newObjects];
        }
        else {
            return [game, gameObject, newObjects];
        }
    }
    else {
        return [game, gameObject, newObjects];
    }
}

